'use client';

import React from 'react';
import { PHASE_META } from '@/lib/curriculum';

interface PhaseProgressBarsProps {
  phaseProgress: Record<number, { complete: number; total: number; pct: number }>;
}

export default function PhaseProgressBars({ phaseProgress }: PhaseProgressBarsProps) {
  return (
    <div
      style={{
        backgroundColor: 'var(--bg-card)',
        border: '1px solid var(--border)',
        borderRadius: '12px',
        padding: '20px',
      }}
    >
      <h2
        style={{
          fontSize: '14px',
          fontWeight: 600,
          color: 'var(--text-primary)',
          marginBottom: '16px',
          letterSpacing: '0.01em',
        }}
      >
        Phase Progress
      </h2>

      <div style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
        {[1, 2, 3, 4, 5, 6].map(phase => {
          const meta = PHASE_META[phase];
          const prog = phaseProgress[phase] ?? { complete: 0, total: meta.weeks[1] - meta.weeks[0] + 1, pct: 0 };

          return (
            <div key={`phase-bar-${phase}`} style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <span
                    style={{
                      fontSize: '11px',
                      fontFamily: 'IBM Plex Mono, monospace',
                      fontWeight: 600,
                      padding: '2px 7px',
                      borderRadius: '4px',
                      backgroundColor: meta.color,
                      color: meta.textColor,
                      border: `1px solid ${meta.border}`,
                      letterSpacing: '0.04em',
                    }}
                  >
                    P{phase}
                  </span>
                  <span style={{ fontSize: '13px', fontWeight: 500, color: 'var(--text-secondary)' }}>
                    {meta.label}
                  </span>
                  <span style={{ fontSize: '11px', color: 'var(--text-muted)' }}>
                    Wk {meta.weeks[0]}–{meta.weeks[1]}
                  </span>
                </div>
                <span
                  style={{
                    fontSize: '12px',
                    fontFamily: 'IBM Plex Mono, monospace',
                    color: prog.pct === 100 ? 'var(--accent)' : 'var(--text-muted)',
                    fontVariantNumeric: 'tabular-nums',
                  }}
                >
                  {prog.complete}/{prog.total}
                </span>
              </div>

              {/* Progress bar track */}
              <div
                style={{
                  height: '6px',
                  borderRadius: '3px',
                  backgroundColor: 'var(--bg-elevated)',
                  overflow: 'hidden',
                }}
              >
                <div
                  style={{
                    height: '100%',
                    width: `${prog.pct}%`,
                    borderRadius: '3px',
                    backgroundColor: meta.textColor,
                    transition: 'width 600ms ease',
                    minWidth: prog.pct > 0 ? '6px' : '0',
                  }}
                />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}